import React from 'react'
import {Avatar, Button, Input, Space} from 'antd'
import {RiSearch2Line} from 'react-icons/ri'
import {HiCheckCircle} from 'react-icons/hi'
import {IoCloseCircle} from 'react-icons/io5'
import {BsPersonFill} from 'react-icons/bs'
import UserLookupComponent from 'components/UserLookupComponent'
import getAvatar from 'helpers/getAvatar'

// Tên hiển thị trong Sổ Gia Đình - Ô NHẬP LUÔN Ở ĐÂY, tự do sửa bất kể đã liên kết tài khoản Kristo
// (member_user_id) hay chưa. Trước đây (AddRelativeForm cũ): chọn xong 1 tài khoản qua
// UserLookupComponent thì Ô TÊN BỊ THAY HẲN BẰNG 1 CHIP CỐ ĐỊNH hiện tên tài khoản, không sửa được
// nữa - tên trang trọng/truyền thống trong gia phả bị tên hiển thị tuỳ tiện trên app "đè" mất, phải
// gỡ liên kết mới gõ lại được (bug thực tế). Đúng mô hình "danh bạ" (Zalo/Contacts, Messenger
// nickname...): tên bạn LƯU cho 1 liên hệ là CỦA RIÊNG SỔ NÀY, độc lập với tên hiển thị công khai
// trên tài khoản người đó - họ đổi tên tài khoản không ảnh hưởng gì tới tên đã ghi trong gia phả. Ở
// đây: input tên luôn hiện + luôn sửa được; tài khoản đã liên kết chỉ là 1 dòng THÔNG TIN PHỤ bên
// dưới (avatar + badge + nút gỡ), không chiếm chỗ/khoá ô nhập.
//
// onLink(userInfo): gọi khi chọn xong 1 tài khoản qua UserLookupComponent - CHỈ lo phần liên kết
// (member_user/member_user_id) + các field khác nếu caller muốn tự map (gender/birth_date/patron_saint...),
// KHÔNG đụng vào `name` - việc tự điền tên (chỉ khi ô đang TRỐNG, không ghi đè tên đã gõ) do component
// này tự quyết định qua onNameChange, tách bạch khỏi field nào caller muốn đồng bộ theo tài khoản.
const PersonNameField = ({name, onNameChange, linkedUser, onLink, onUnlink, placeholder, t}) => (
    <div className="flex flex-col gap-1.5">
        <Space.Compact style={{display: 'flex', width: '100%'}}>
            <Input
                size="large"
                value={name}
                onChange={(e) => onNameChange(e.target.value)}
                allowClear
                placeholder={placeholder}
                className="flex-1"
            />
            <UserLookupComponent
                handleApply={(userInfo) => {
                    if (!name && userInfo?.name) onNameChange(userInfo.name)
                    onLink(userInfo)
                }}>
                <Button
                    size="large"
                    type="primary"
                    icon={<RiSearch2Line size={14}/>}
                    className="flex flex-center"
                />
            </UserLookupComponent>
        </Space.Compact>
        {linkedUser ? (
            <div className="p-2 flex items-center gap-2 border border-green-400 bg-green-50 rounded-lg">
                <Avatar
                    size={28}
                    src={getAvatar(linkedUser)}
                    icon={<BsPersonFill size={14} className="text-color-500"/>}
                    className="flex-shrink-0 flex flex-center background-200"
                />
                <div className="flex flex-col flex-1 min-w-0">
                    <span className="text-2xs font-semibold text-color-000 truncate">{linkedUser.name}</span>
                    <span className="flex items-center gap-1 text-2xs text-green-700 italic">
                        <HiCheckCircle size={11} className="flex-shrink-0"/>
                        {t('linked account')}
                    </span>
                </div>
                <IoCloseCircle
                    size={18}
                    onClick={onUnlink}
                    className="flex-shrink-0 text-color-300 hover:text-color-600 cursor-pointer"
                />
            </div>
        ) : (
            <span className="text-xs text-color-500 italic leading-tight">
                {`* `}
                {t('click on {n} to, lookup user accounts on the {m} platform', {
                    n: <RiSearch2Line size={13} className="mx-1 text-color-000"/>,
                    m: <span className="font-bold text-blue-600 tracking-widest">{'Kristo Network'}</span>,
                })}
            </span>
        )}
    </div>
)

export default PersonNameField
